import script from "./DetailHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailHeader.vue?vue&type=script&setup=true&lang=js"

import "./DetailHeader.vue?vue&type=style&index=0&id=a7a58128&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7a58128"]])

export default __exports__